import dynamic from 'next/dynamic';
const TrustedbyStats = dynamic(() => import('./TrustedbyStats'));
export default TrustedbyStats;
